import qs from 'qs';
import request from '../index';

// 获取返修设备列表
export const getRepairEquipmentList = (params) => request.get('/api-qc/getRepairEquipmentList', { params });

// 新增返修设备
export const saveOrUpdateRepairEquipment = (data) => request.post('/api-qc/saveOrUpdateRepairEquipment', data);

// 创建用户
export const saveOrUpdateUser = (data) => request.post(`api-qc/saveOrUpdateUser`, data);

// 登录
export const login = (data) => request.post(`api-qc/login`, qs.stringify(data));

// 上传文件
// export const uploadAttachment = (data, processFn) => request.post('api-qc/uploadAttachment', data, {
//     onUploadProgress: processFn,
//     timeout: 1800000,
// });
// 上传文件
export const uploadAttachment = (data) => request.post('api-qc/uploadAttachment', data, {
    timeout: 1800000,
});

// 获取天鸽配件
export const getColumbaAccessoryByRepairEquipmentId = (params) => request.get('/api-qc/getColumbaAccessoryByRepairEquipmentId', { params });

// 新增天鸽配件
export const saveOrUpdateColumbaAccessory = (data) => request.post('/api-qc/saveOrUpdateColumbaAccessory', data);

// 获取天鹅配件
export const getSwanAccessoryByRepairEquipmentId = (params) => request.get('/api-qc/getSwanAccessoryByRepairEquipmentId', { params });

// 新增天鹅配件
export const saveOrUpdateSwanAccessory = (data) => request.post('/api-qc/saveOrUpdateSwanAccessory', data);

// 新增/修改返修过程
export const saveOrUpdateRepairProcess = (data) => request.post('/api-qc/saveOrUpdateRepairProcess', data);

// 流程确认
export const processConfirmation = (params) => request.get('/api-qc/processConfirmation', { params });

// 流程回退
export const processRollback = (params) => request.get('/api-qc/processRollback', { params });

// 获取设备返修过程记录
export const getRepairProcess = (params) => request.get('/api-qc/getRepairProcess', { params });

// 获取返修设备
export const getOneRepairEquipment = (params) => request.get('/api-qc/getOneRepairEquipment', { params });

// 删除返修设备记录
export const deleteRepairEquipment = (data) => request.delete('/api-qc/deleteRepairEquipment', { data });

// 获取进度统计
export const getRepairStatistics = () => request.get('/api-qc/getRepairStatistics');

// 获取用户列表
export const getUserList = (params) => request.get('/api-qc/getUserList', { params });

// 删除用户
export const deleteUser = (data) => request.delete('/api-qc/deleteUser', { data });

// 开启返修流程
export const startRepairProcess = (params) => request.get('/api-qc/startRepairProcess', { params });

// 仓管确认
export const warehouseConfirm = (params) => request.get('/api-qc/warehouseConfirm', { params });

// 质检确认
export const customerIssuesConfirm = (params) => request.get('/api-qc/customerIssuesConfirm', { params });

// 机器维修生产确认
export const machineMaintenanceConfirm = (params) => request.get('/api-qc/machineMaintenanceConfirm', { params });

// 维修方案工艺确认
export const maintenancePlanConfirm = (params) => request.get('/api-qc/maintenancePlanConfirm', { params });

export const closedLoopConfirm = (params) => request.get('/api-qc/closedLoopConfirm', { params });


// 修改天鸽配件
export const updateColumbaAccessory = (data) => request.put('/api-qc/updateColumbaAccessory', data);

// 修改天鹅配件
export const updateSwanAccessory = (data) => request.put('/api-qc/updateSwanAccessory', data);

// 修改客户问题
export const updateCustomerIssues = (data) => request.put('/api-qc/updateCustomerIssues', data);

// 修改机器维修
export const updateMachineMaintenance = (data) => request.put('/api-qc/updateMachineMaintenance', data);

// 修改机器维修
export const updateMaintenancePlan = (data) => request.put('/api-qc/updateMaintenancePlan', data);

// 修改闭环
export const updateClosedLoop = (data) => request.put('/api-qc/updateClosedLoop', data);

// 新增或修改根本原因
export const saveOrUpdateRootCauseAnalysis = (data) => request.post('/api-qc/saveOrUpdateRootCauseAnalysis', data);

// 审核通过
export const finalAudit = (params) => request.get('/api-qc/finalAudit', { params });

// 客户问题质检回退
export const customerIssuesRollback = (params) => request.get('/api-qc/customerIssuesRollback', { params });

// closedLoopRollback
export const closedLoopRollback = (params) => request.get('/api-qc/closedLoopRollback', { params });

// 机器维修生产回退
export const machineMaintenanceRollback = (params) => request.get('/api-qc/machineMaintenanceRollback', { params });

// 维修方案工艺回退
export const maintenancePlanRollback = (params) => request.get('/api-qc/maintenancePlanRollback', { params });

// 新增或者修改内容描述
export const saveOrUpdateContentDesc = (data) => request.post('/api-qc/saveOrUpdateContentDesc', data);

// 新增or修改质检检验报告
export const saveOrUpdateInspectionReport = (data) => request.post('/api-qc/saveOrUpdateInspectionReport', data);
